import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Processa o retorno do Google Auth (session_id no fragmento da URL),
// troca por um token do app no backend e redireciona ao portal.
const GoogleCallback = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const portal = sessionStorage.getItem('google_portal') || 'candidate';
    sessionStorage.removeItem('google_portal');
    const loginPath = portal === 'admin' ? '/portal/admin/login' : '/portal/candidato/login';
    const homePath = portal === 'admin' ? '/portal/admin' : '/portal/candidato';

    if (!sessionId) { navigate(loginPath); return; }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/google`, { session_id: sessionId, portal });
        login(res.data.user, res.data.token);
        window.history.replaceState(null, '', window.location.pathname);
        navigate(homePath);
      } catch (e) {
        window.history.replaceState(null, '', window.location.pathname);
        navigate(loginPath, { state: { googleError: e.response?.data?.detail || 'Não foi possível entrar com o Google.' } });
      }
    })();
  }, [login, navigate]);

  return (
    <div data-testid="google-callback-loading" className="min-h-screen flex flex-col items-center justify-center bg-slate-50 gap-4">
      <div className="w-10 h-10 border-4 border-hm-orange border-t-transparent rounded-full animate-spin" />
      <p className="text-slate-600 font-medium">Entrando com o Google...</p>
    </div>
  );
};

export default GoogleCallback;
